import React from 'react';
import { Field } from 'formik';
import TextField from '../TextField';

export const recoupmentPercentColumnAsListItem = () => {
  return {
    key: 'recoupmentPercentage',
    name: 'Recoup%',
    maxWidth: 55,
    data: 'number',
    fieldName: 'recoupmentPercentage',
  };
};

export const recoupmentPercentColumn = (formikField = 'filters') => {
  return {
    key: 'recoupmentPercentage',
    name: 'Recoup%',
    maxWidth: 55,
    onRender: (filter, index) => {
      return (
        <Field
          name={`${formikField}.${index}.recoupmentPercentage`}
          component={TextField}
          type="number"
          min={0}
          max={100}
        />
      );
    },
  };
};
